export const contractOptions = [
  { value: "lsfhp", label: "สัญญา 1" },
  { value: "vsfhp", label: "สัญญา 2" },
  { value: "psfhp", label: "สัญญา 3" },
  { value: "rpsl", label: "สัญญา 3(ใหม่) (P-loan)" },
  { value: "sfhp", label: "สัญญา 8" },
];

export const lawyerOptions = [
  { value: "sakon", label: "ทนายสกล" },
  { value: "pongsara", label: "ทนายแรมโบ้" },
];